import { createAction } from 'redux-actions';

export const REQUEST_PREDICTION = 'REQUEST_PREDICTION';
export const SUCCESS_PREDICTION = 'SUCCESS_PREDICTION';
export const FAILURE_PREDICTION = 'FAILURE_PREDICTION';
export const requestPrediction = createAction(REQUEST_PREDICTION);
export const successPrediction = createAction(SUCCESS_PREDICTION);
export const failurePrediction = createAction(FAILURE_PREDICTION);